import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() inline:boolean = false;
  @Input() diameter: number = 50;
  constructor() { }

  ngOnInit(): void {
  }

}
